import { Stack } from '@asgard/ui-library';

import { PageContentContainer } from 'components/layout/Page.styled';
import HtmlTrans from 'components/shared/HtmlTrans';
import { useI18n } from 'hooks/useI18n';
import { TalentIntro } from '../components/intro/TalentIntro';
import { TalentRecruitingStyles } from './TalentRecruiting.styles';

export const TalentRecruiting: React.FC = () => {
  const { t } = useI18n('talent-new');

  return (
    <TalentRecruitingStyles.Root>
      <Stack direction="column" gap="4xl">
        <PageContentContainer containerSize="xl">
          <TalentIntro
            className="intro"
            title={t('talent-new.recruiting.title')}
            desc={t('talent-new.recruiting.desc')}
          />

          <Stack direction="column" gap="l">
            <PageContentContainer containerSize="lg">
              <Stack direction="column" gap="4xl">
                {Array.from({ length: 4 }).map((_, index) => (
                  <TalentRecruitingStyles.CardContent1 key={index}>
                    <div>
                      <Stack className="title" alignment="center" gap="s">
                        <strong>
                          {t(`talent-new.recruiting.feature${index + 1}.pro`)}
                        </strong>
                        <em>{t('talent-new.recruiting.vs')}</em>
                        <span>
                          {t(`talent-new.recruiting.feature${index + 1}.con`)}
                        </span>
                      </Stack>

                      <HtmlTrans
                        ns="talent-new"
                        i18nKey={`talent-new.recruiting.feature${
                          index + 1
                        }.desc`}
                      />
                    </div>
                  </TalentRecruitingStyles.CardContent1>
                ))}
              </Stack>
            </PageContentContainer>
          </Stack>
        </PageContentContainer>
      </Stack>
    </TalentRecruitingStyles.Root>
  );
};

export default TalentRecruiting;
